export default __webpack_public_path__ + "static/media/RedCrossError.0988652d.svg";